import React from "react";
import { DialogWrapper } from "../../components/Dialog";
import { SubTitle } from "../../components/molecules/subtitle";
import { TransparentButton } from "../../components/Button/TransparentButton";
import useUserDetailsStore from "../../store/UserStore";
import { CircularProgress } from "@mui/material";

export default function DeleteAccountDialog({ showDeleteDialog, onClose }) {
  const [deleting, deleteAccount] = useUserDetailsStore((state) => [
    state.deleting,
    state.deleteAccount,
  ]);

  return (
    <DialogWrapper
      isOpen={showDeleteDialog}
      onClose={() => {
        onClose();
      }}
    >
      <div className="flex flex-col items-center gap-4 pb-8">
        <SubTitle className="text-xl">
          Are you sure you want to delete this account?
        </SubTitle>
        <SubTitle className="text-[22px]">
          Your active plan, story, and other details will be removed
          permanently.
        </SubTitle>

        <div className="flex gap-4">
          <TransparentButton
            disabled={deleting}
            handleButtonClick={() => {
              onClose(false);
            }}
            style={{ marginTop: 0 }}
            theme="red"
          >
            Cancel
          </TransparentButton>
          <TransparentButton
            className={"min-w-[150px]"}
            disabled={deleting}
            handleButtonClick={() => {
              deleteAccount();
            }}
            style={{ marginTop: 0 }}
          >
            {deleting ? <CircularProgress size={22} /> : <span>Confirm</span>}
          </TransparentButton>
        </div>
      </div>
    </DialogWrapper>
  );
}
